import * as React from 'react';
import { SWRConfig } from 'swr';
import MiniCartProvider from 'context/miniCart';

export const FrontasticProvider = ({ children }: React.PropsWithChildren) => {
  return (
    <SWRConfig>
      <MiniCartProvider>{children}</MiniCartProvider>
    </SWRConfig>
  );
};
